import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { isMobileWebBrowser, mobile } from "src/utils/platformUtils";

interface RedirectUsertoAppDialogProps {
  open: boolean;
  onClose: () => void;
}

const RedirectUsertoAppDialog: React.FC<RedirectUsertoAppDialogProps> = ({ open, onClose }) => {
  const isMobile = isMobileWebBrowser() || mobile;

  useEffect(() => {
    console.log("🎯 RedirectUsertoAppDialog - open prop:", open);
  }, [open]);
  const handleAppStoreRedirect = () => {
    // Deep link to App Store - adjust URL when app is published
    window.open("https://apps.apple.com/us/app/rotogpt/id6736617092", "_blank");
  };

  const handleGooglePlayRedirect = () => {
    // Deep link to Google Play - adjust URL when app is published
    window.open("https://play.google.com/store/apps/details?id=com.rotogpt.chat", "_blank");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disablePortal={false}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
      sx={{
        zIndex: 1500, // Higher than Drawer z-index (1400)
        "& .MuiDialog-container": {
          zIndex: 1500,
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: PureLightThemeCaaS.colors.alpha.black[100],
          color: PureLightThemeCaaS.colors.alpha.white[100],
          boxShadow: "4px 4px 12px rgba(0,0,0,0.25)",
          borderRadius: "8px",
          border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
          backdropFilter: "none",
          WebkitBackdropFilter: "none",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            position: "fixed",
            backdropFilter: "blur(6px) !important",
            WebkitBackdropFilter: "blur(1px) !important",
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            // zIndex: 1499,
          },
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ color: PureLightThemeCaaS.colors.alpha.white[100], fontWeight: "bold", fontSize: "18px" }}>Get Full Access</Typography>
          <IconButton aria-label="close" onClick={onClose} sx={{ ml: 1, color: PureLightThemeCaaS.colors.alpha.white[100] }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography sx={{ color: PureLightThemeCaaS.colors.alpha.white[100], fontWeight: 500, fontSize: "14px", lineHeight: "1.2" }}>
          You've reached your free limit! Download the RotoGPT app to unlock full access.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 1, gap: 1, flexDirection: "row", width: isMobile ? "90%" : "70%", margin: "0 auto", "& > *": { marginLeft: "0 !important" } }}>
        <Button
          fullWidth
          onClick={handleAppStoreRedirect}
          sx={{
            // width: isMobile ? "90%" : "50%",
            color: PureLightThemeCaaS.colors.alpha.white[100],
            backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
            // fontFamily: '"Inter", sans-serif',
            height: "40px",
            p: 1,
            fontSize: "12px",
            lineHeight: 1,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
            },
          }}
        >
          Download on the App Store
        </Button>
        <Button
          fullWidth
          onClick={handleGooglePlayRedirect}
          sx={{
            // width: isMobile ? "90%" : "50%",
            color: PureLightThemeCaaS.colors.alpha.white[100],
            backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
            // fontFamily: '"Inter", sans-serif',
            height: "40px",
            p: 1,
            fontSize: "12px",
            lineHeight: 1,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
            },
          }}
        >
          Get it on Google Play
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RedirectUsertoAppDialog;
